<a [href]="'/map/artist/' + project.project_slug" class="preview" (click)="clickProject($event)">
    <span class="image" [style]="project.project_image ? ('background-image: url(\'' + project.project_image + '\')') : ''"></span>
    <span class="text">
        <span class="description" [innerHTML]="project.project_name"></span>
        <span class="name" [innerHTML]="project.artist_name"></span>
        <div class="location"[innerHTML]="project.art_location"></div>
        <span class="more">Learn More</span>
    </span>
</a>